























































































import { Event, FormField, Form, FormStep } from 'inscreva-sse-models';
import { ValidationProvider } from 'vee-validate';
import { Component, Vue, Prop } from 'vue-property-decorator';

import DynamicFieldsForm from './DynamicFieldsForm.vue';
import DynamicForm from './inscreva-sse/DynamicForm.vue';

@Component({
  components: {
    DynamicForm,
    DynamicFieldsForm,
  },
})
export default class StepRegistrationComponent extends Vue {
  @Prop({ required: true })
  private event!: Event & { accept_term?: string };

  private isCreatingField: boolean = false;

  $refs!: {
    dynamicFieldsForm: DynamicFieldsForm;
    acceptTerm: any;
    acceptTermValidation: InstanceType<typeof ValidationProvider>;
  };

  get form_without_obligatories(): Form {
    return {
      ...this.form,
      fields: this.form.fields.filter(({ priority }) => priority?.group !== 'personal-info'),
    };
  }

  get is_new_event(): boolean {
    return !this.event._id;
  }

  get is_editing_field(): boolean {
    return this.$refs.dynamicFieldsForm?.isEditingField;
  }

  get suggested_term(): string {
    const eventName = this.event.info.name.toUpperCase();
    const companyName = (this.event.organizer.companyName || 'Anônima').toUpperCase();
    return `O Evento ${eventName}, promovido pela empresa ${companyName} criado pelo sistema Inscreva-SSe. \nNão tem por parte dos Participantes e também da empresa ${companyName} e parceiros, nenhum compromisso financeiro anterior e posterior ao Evento. \nO Participante entende que este é um Evento livre, limitado a capacidade do espaço onde será realizado, e as inscrições serão aceitas na ordem cronológica de inscrição. \nEntende ainda que caso aconteça algum imprevisto que não seja possível realizar alguma atividade, ou mesmo o Evento, os Organizadores não serão responsabilizados por qualquer “prejuízo” pelo Participante.`;
  }

  get is_using_suggested_term(): boolean {
    return this.event.accept_term === this.suggested_term;
  }

  get form_obligatory(): Form {
    return {
      type: 'form',
      fields: this.obligatory_fields,
    };
  }

  get obligatory_fields(): Array<FormField> {
    return [
      {
        id: 'nome',
        type: 'field',
        validations: 'required',
        text: 'Nome',
        name: 'nome',
        priority: {
          level: 0,
          group: 'personal-info',
        },
      },

      {
        id: 'email',
        type: 'field',
        validations: 'required',
        text: 'Email',
        name: 'email',
        priority: {
          level: 0,
          group: 'personal-info',
        },
      },
    ];
  }

  get form(): Form {
    return (this.event.steps.find(({ type }) => type === 'form') as FormStep)?.form;
  }

  created() {
    const hasFormStep: boolean = !!this.form;
    if (!hasFormStep) {
      this.event.steps = this.event.steps || [];
      this.event.steps.unshift({
        info: {
          title: 'Registro',
        },
        type: 'form',
        form: {
          fields: this.obligatory_fields,
        } as Form,
      } as FormStep);
    }
  }

  onCreationFieldStatusChange(isCreatingField: boolean) {
    this.isCreatingField = !!isCreatingField;
  }

  onAddField(field: FormField) {
    this.isCreatingField = false;
    this.form.fields.push(field);
  }

  onFieldButtonClick({ id, field }: { id: string; field: FormField }) {
    if (id === 'delete') {
      this.deleteField(field);
    }
  }

  isOption(field: FormField): boolean {
    return field.type === 'option';
  }

  updateEventForm() {
    const formIndex: number = this.event.steps.findIndex((step) => step.type === 'form');
    const index: number = formIndex !== -1 ? formIndex : this.event.steps.length;
    this.event.steps[index] = {
      ...(this.event.steps[index] || {}),
      form: this.form,
    } as FormStep;
    this.$emit('on-update', this.event);
  }

  deleteField({ id }: FormField) {
    const fieldIndex: number = this.form.fields.findIndex((field) => field.id === id);
    this.form.fields.splice(fieldIndex, 1);
    this.updateEventForm();
  }

  async onSelectUseSuggestedTerm($event: any) {
    if (!$event.target?.checked) {
      return;
    }
    this.event.accept_term = this.suggested_term;
    this.$refs.acceptTerm.value = this.event.accept_term;
    await this.$refs.acceptTermValidation?.syncValue(this.event.accept_term);
    await this.$refs.acceptTermValidation
      ?.validate()
      .then(({ errors }) => this.$refs.acceptTermValidation.setErrors(errors));
    return (await this.$refs.acceptTermValidation?.validate())?.valid;
  }
}
